function isTouchDevice() {
  return 'ontouchstart' in window || navigator.maxTouchPoints > 0 || navigator.msMaxTouchPoints > 0;
}

let lastInputWasTouch = false;
let usingMouseOnTouchDevice = false;

function updateInputMethod(event) {
  if (event.type.startsWith('touch')) {
    lastInputWasTouch = true;
    usingMouseOnTouchDevice = false;
  } else if (event.type === 'mousemove' || event.type === 'mousedown') {
    if (isTouchDevice() && !lastInputWasTouch) {
      usingMouseOnTouchDevice = true;
    } else if (lastInputWasTouch) {
      usingMouseOnTouchDevice = true;
      setTimeout(() => {
        lastInputWasTouch = false;
      }, 1000);
    }
  }
}

document.addEventListener('DOMContentLoaded', () => {
  const menuContainer = document.querySelector('.header__inline-menu');
  const menuItems = document.querySelectorAll('.header__inline-menu details');

  if (!menuContainer) return;

  document.addEventListener('touchstart', updateInputMethod, { passive: true });
  document.addEventListener('touchend', updateInputMethod, { passive: true });
  document.addEventListener('mousemove', updateInputMethod, { passive: true });
  document.addEventListener('mousedown', updateInputMethod, { passive: true });

  menuContainer.addEventListener('click', handleEvent);
  menuContainer.addEventListener('pointerdown', handleEvent);
  menuContainer.addEventListener('pointerup', handleEvent);
  menuContainer.addEventListener('mouseover', handleEvent);

  menuItems.forEach((item) => {
    item.addEventListener('mouseleave', () => {
      if (!isTouchDevice() || usingMouseOnTouchDevice) {
        item.removeAttribute('open');
      }
      document.body.classList.remove('mega-menu-active');
    });
  });

  function handleEvent(event) {
    const item = event.target.closest('details');
    if (!item || !menuContainer.contains(item)) return;

    if (event.type === 'touchstart') {
      lastInputWasTouch = true;
      usingMouseOnTouchDevice = false;
      if (!isTouchDevice()) event.preventDefault();
      item.setAttribute('open', true);
      document.body.classList.add('mega-menu-active');
    }

    if (event.type === 'touchend') {
      if (!isTouchDevice()) event.preventDefault();
      item.removeAttribute('open');
      document.body.classList.remove('mega-menu-active');
    }

    if (event.type === 'mouseover' && (!isTouchDevice() || usingMouseOnTouchDevice)) {
      item.setAttribute('open', true);
      document.body.classList.add('mega-menu-active');
    }
  }

  function applyMegaMenuColumns() {
    if (window.innerWidth < 989) {
      document.querySelectorAll('sticky-header .mega-menu__list').forEach((megaMenuList) => {
        megaMenuList.style.removeProperty('column-count');
        megaMenuList.style.removeProperty('width');
      });
      return;
    }

    // Select all mega menu lists
    const megaMenuLists = document.querySelectorAll('sticky-header .mega-menu__list');

    megaMenuLists.forEach((megaMenuList) => {
      if (megaMenuList.classList.contains('masonry_override')) {
        return;
      }

      const allListItems = megaMenuList.querySelectorAll('li');
      const totalItems = allListItems.length;
      let columnCount = 1;
      let widthCalc = 33.3333;

      if (totalItems >= 15) {
        columnCount = 2;
        widthCalc = 66.6666;
      }
      if (totalItems > 30) {
        columnCount = 3;
        widthCalc = 100;
      }
      megaMenuList.style.columnCount = columnCount;
      megaMenuList.style.width = `calc(${widthCalc}% - 2.4rem)`;
    });
  }

  applyMegaMenuColumns();
  let resizeTimer;
  window.addEventListener('resize', () => {
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(applyMegaMenuColumns, 250);
  });
});
